import React from 'react';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import loader from '../../../../assets/Image/Loader2.gif';
import LoadingOverlay from "../../../common/LoadingBar";
const TransactionTable = ({ 
  data, 
  loading, 
  currentPage, 
  totalPages, 
  onPageChange, 
  onPrint,
  compact = false,
  rowsPerPage = 10
}) => {
  return (
    <>
      <div className="transaction-table-wrapper">
        {loading ? (
           <LoadingOverlay loading={loading} loader={loader} />
        ) : data.length === 0 ? (
          <p style={{ textAlign: 'center', padding: '20px', color: '#666' }}>No transactions yet</p>
        ) : (
          <table className={`data-table custom-table ${compact ? 'pos-dashboard-table' : ''}`}>
            <thead className="table-header-pos">
              <tr>
                <th scope="col" className="no-column">No</th>
                <th scope="col">Invoice</th>
                <th scope="col">Date</th>
                <th scope="col">Qty</th>
                <th scope="col">Amount</th>
                <th scope="col" className="action-column">Action</th>
              </tr>
            </thead>
            <tbody className="table-body-pos">
              {data.map((item, index) => (
                <tr key={item.id}>
                  <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                  <td>{item.invoice_no}</td>
                  <td>{item.date}</td>
                  <td>{item.qty}</td>
                  <td>₹{parseFloat(item.total_amount).toFixed(2)}</td>
                  <td className="action-column">
                    <button className="action-button" onClick={() => onPrint(item.id)} title="Print">
                      <PrintOutlinedIcon style={{ fontSize: compact ? '16px' : '18px', color: '#666' }} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      {!loading && totalPages > 1 && (
        <div className="transaction-pagination">
          <button 
            className="pagination-btn" 
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            ‹
          </button>
          <span className="pagination-info">{currentPage} / {totalPages}</span>
          <button 
            className="pagination-btn"
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            ›
          </button>
        </div>
      )}
    </>
  );
};

export default TransactionTable;
